import history from "history/browser";
import queryString from "query-string";
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

jQuery(($) => {

    function hideListings(listings) {
        let height = 0;
        $(listings).children().each((index, section) => height += $(section).outerHeight());
        gsap.set(listings, { height: height });
        $(listings).children().each((index, section) => {
            gsap.to($(section).children(), {
                opacity: 0,
                duration: 0.3,
                onComplete: () => {
                    $(section).remove();
                }
            });
        });
    }

    document.addEventListener("refresh-scroll", () => {
        ScrollTrigger.refresh(true)
    });

    let listings = document.querySelector('.js-article-listings');

    if (listings) {
        let endpoint = listings.getAttribute('data-endpoint');
        let load_more_endpoint = listings.getAttribute('data-load_more_endpoint');
        let load_endpoint = listings.getAttribute('data-load_endpoint');
        let ignore_insert = listings.getAttribute('data-ignore_insert') === 'true';
        if (endpoint) {
            history.listen(({ action, location }) => {
                // @todo Need a transition here to remove the listings before we load in the new ones
                hideListings(listings)
                let search = queryString.parse(location.search);
                $.ajax({
                    url: load_endpoint,
                    data: { page: 1, category: search.category, ignore_insert: ignore_insert },
                })
                    .then((response) => {
                        $(listings).html(response.html);
                        gsap.set(listings, { clearProps:"all" });
                        setTimeout(() => {
                                document.dispatchEvent(new CustomEvent('masonry-load'));
                                document.dispatchEvent(new CustomEvent('reload-layout', { detail: listings }));
                                document.dispatchEvent(new CustomEvent('refresh-scroll'));
                            },
                            300
                        );
                    });
            });
        }
        document.addEventListener("load-more", (event) => {
            let search = queryString.parse(location.search);
            $.ajax({
                url: load_more_endpoint,
                data: { page: event.detail.page, category: search.category },
            })
                .then((response) => {
                    let elements = [];
                    let primaryListing = listings.querySelector('.js-article-listings--more');
                    $(response['listings']).filter('.blog-entry').each((index, element) => {
                        $(primaryListing).append($(element));
                        elements.push(element);
                    });
                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent('masonry-reload', { detail: { items: elements } }));
                        document.dispatchEvent(new CustomEvent('loaded-more', { detail: { page: response.page, hasMore: response.hasMore } }));
                        document.dispatchEvent(new CustomEvent('refresh-scroll'));
                    }, 300);
                });
        });
    }
})
